module.exports = __webpack_public_path__ + "img/1.6e25e371.webp";